/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { ErrorModel } from '../model/error.model';
import { ErrorSeverityEnum } from '../consts/error-severity.enum';

//TODO rename to iriroCustomArrayItemsFieldEqualTo
@Directive({
  selector: '[customArrayItemsFieldEqualTo], [iriro-customArrayItemsFieldEqualTo]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: CustomArrayItemsFieldEqualToValidator,
      multi: true,
    }
  ],
})
export class CustomArrayItemsFieldEqualToValidator implements Validator {
  @Input() fieldName = '';
  @Input() value: string | number | boolean | undefined = undefined;

  validate(control: AbstractControl): { [key: string]: any } | null {
    const funcProperties = {
      field: this.fieldName,
      value: this.value,
    };
    return _customArrayItemsFieldEqualToValidation.bind(funcProperties)(
      control
    );
  }
}

export const customArrayItemsFieldEqualToValidation = (
  fieldName = '',
  value: any
): ValidatorFn => {
  const funcProperties = {
    field: fieldName,
    value: value,
  };

  return _customArrayItemsFieldEqualToValidation.bind(funcProperties);
};

function _customArrayItemsFieldEqualToValidation(this: any, control: AbstractControl): {
  [key: string]: any;
} | null {
  let errors: ErrorModel | null = null;

  if (control.value.length > 0) {
    const filter: any[] = control.value.filter(
      (value: any) => value[this.field] !== this.value
    );
    if (filter.length > 0) {
      errors = {
        severity: ErrorSeverityEnum.error,
        message: 'arrayItemsField' + this.field + 'NotEqualTo',
      };
    }
  }

  return errors ? errors : null;
}
